'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
const SENSITIVE_QUERY_KEYS = new Set(['login', 'username', 'email', 'password', 'pass', 'pwd']);
function sanitizeSensitiveQueryParams(): void {
  if (typeof window === 'undefined') {
    return;
  }
  const url = new URL(window.location.href);
  let changed = false;

  // URLSearchParams keys are case-sensitive; normalize before matching.
  const keys = Array.from(url.searchParams.keys());
  for (const key of keys) {
    if (SENSITIVE_QUERY_KEYS.has(key.toLowerCase())) {
      url.searchParams.delete(key);
      changed = true;
    }
  }
  if (!changed) {
    return;
  }
  const newUrl = url.pathname + (url.searchParams.toString() ? `?${url.searchParams.toString()}` : '') + url.hash;

  // Avoid Next/router involvement; this is a pure URL cleanup for security.
  window.history.replaceState(window.history.state, '', newUrl);
}
export default function SensitiveQueryParamsScrubber() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  useEffect(_temp, t0);
  return null;
}
function _temp() {
  sanitizeSensitiveQueryParams();
}